import palette from '../palette'
import typography from '../typography'

const MuiLink = {
  root: {
    color: palette.primary.main,
    fontFamily: typography.fontFamily,
    fontSize: typography.body1.fontSize,
  },
}

export default MuiLink
